import styled from "styled-components";

const Container = styled.div`
  padding-right: 0px;
  padding-left: 0px;

  @media (min-width: 0px) and (max-width: 767px) {
    padding-left: 15px;
    padding-right: 15px;
  }
`;
export default Container;
